import { createApp } from 'vue'
import VueKonva from 'vue-konva'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from './i18n/config'
import { loadFonts } from './plugins/webfontloader'
import { emitter } from '@/eventBus/eventBus'
import router from './router/index'
import store from "./store/index"
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vue3Lottie from 'vue3-lottie'

const app = createApp(App);

loadFonts()

app.config.globalProperties.emitter = emitter;

app
  .use(VueKonva)
  .use(router)
  .use(vuetify)
  .use(i18n)
  .use(store)
  .use(Vue3Lottie)
  .use(Toast)
  .component('QuillEditor', QuillEditor) 
  .mount('#app')
